import {SODeleteProduct} from '../../core/product/so-delete-product';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteProduct extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteProduct;
}